(function () {
  const cartLink = document.getElementById('cart-icon-bubble');
  if (!cartLink) return;

  function getCount() {
    return cartLink.querySelector('.cart-count-bubble span[aria-hidden]')?.textContent;
  }

  let lastCount = getCount();

  function pulse() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    cartLink.classList.remove('cart-icon-bounce');
    void cartLink.offsetWidth;
    cartLink.classList.add('cart-icon-bounce');

    const bubble = cartLink.querySelector('.cart-count-bubble');
    if (bubble) {
      bubble.classList.remove('cart-count-pop');
      void bubble.offsetWidth;
      bubble.classList.add('cart-count-pop');
    }
  }

  const observer = new MutationObserver(() => {
    const newCount = getCount();
    if (newCount !== lastCount) {
      lastCount = newCount;
      pulse();
    }
  });

  observer.observe(cartLink, { childList: true, subtree: true });
})();
